import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import { TextComponent } from "./TextComponent";

interface NavItemProps {
    title: string;
    icon?: JSX.Element;
    iconFilled?: JSX.Element;
    href?: string;
    variant?: string;
    hiddenText?: boolean;
    className?: string;
    onClick?: () => void;
}

export const NavItem = ({ title, icon, iconFilled, href = "#", variant, hiddenText = false, onClick, className }: NavItemProps) => {
    const baseClass = `flex transition-all duration-300 ease-in-out select-none ${className ?? ""}`;
    const location = useLocation();
    const isActive = variant === "header"
        ? location.pathname === href 
        : (href === "/" ? location.pathname === href : location.pathname.startsWith(href));

    let combinedClass;

    if (variant === "header") {
        combinedClass = `pb-2 border-b-2 hover:border-b-primary hover:text-primary ${baseClass} ${isActive ? 'border-b-primary text-primary font-bold' : 'text-graySecondary border-b-transparent'}`
    } else {
        combinedClass = `items-center rounded-2xl ${baseClass} max-md:min-w-0 max-md:flex-1 max-md:flex-col max-md:justify-center max-md:gap-1 md:gap-3 md:p-3 ${isActive ? 'text-primary font-semibold' : 'text-slate-800 hover:bg-grayLight max-md:text-slate-500 max-md:hover:bg-transparent max-md:hover:text-primary'}`
    }

    return (
        <li className={`max-md:flex max-md:flex-1 max-md:justify-center max-md:px-1 ${className?.includes("max-md:hidden") ? "max-md:hidden" : ""}`}>
            <Link
                to={href}
                className={combinedClass}
                onClick={onClick}
            >
                {iconFilled ?
                    <>
                        {isActive || onClick ? <>{iconFilled}</> : <>{icon}</>}
                    </>
                :
                    <>
                        {icon}
                    </>
                }
                <TextComponent variant="h5" className={`${hiddenText ? "max-md:block" : ""} max-md:text-[10px] max-md:leading-none max-md:font-semibold max-md:tracking-normal max-md:truncate`}>
                    {title}
                </TextComponent>
            </Link>
        </li>
    );
};
